exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".list-stage-planner .level-border-title{padding:30px 0 8px;position:relative;font-size:1.2em;font-weight:700;color:#000}.list-stage-planner .level-border-title:before{content:\"\";position:absolute;bottom:10px;width:106%;height:1px;transform:skew(-37deg) translateX(-8%);border-bottom-style:solid;border-width:8px;border-bottom-color:inherit;z-index:-1;border-radius:2px}", ""]);

// exports
